import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getRecaptchaToken } from '../utils/recaptchaEnterprise';
import { verifyTokenOnServer } from '../utils/recaptchaVerify';

export default function Login() {
  const { login, loginWithGoogle, user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!authLoading && user) navigate('/');
  }, [authLoading, user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
  setIsSubmitting(true);
    setError('');
    try {
      // Get a reCAPTCHA Enterprise token for the LOGIN action
      try {
        const action = 'LOGIN';
        const siteKey = process.env.REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY || '6Lc7PO8rAAAAALb_xbeAQJt0qxid5YASCC9oF86P';
        const token = await getRecaptchaToken(action, siteKey);
        const res = await verifyTokenOnServer({ token, action, siteKey });
        if (res && res.ok === false) {
          throw new Error('reCAPTCHA verification failed');
        }
      } catch (rcErr) {
        console.warn('reCAPTCHA verify skipped/failed:', rcErr?.message || rcErr);
      }
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.message || 'Failed to sign in');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleGoogle = async () => {
    setIsSubmitting(true);
    setError('');
    try {
      await loginWithGoogle();
      // If redirect flow is used, navigation will happen after redirect.
      navigate('/');
    } catch (err) {
      setError(err?.message || 'Google sign-in failed');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{ paddingTop: '4rem', display: 'flex', justifyContent: 'center' }}>
      <form onSubmit={handleSubmit} className="glass-card form-glass" style={{ padding: 24 }}>
        <h2 className="card-title" style={{ marginTop: 0 }}>Log In</h2>
  {error && <div className="meta-text" style={{ color: '#ff6b6b', marginBottom: 8 }}>{error}</div>}
        <label style={{ display: 'block', textAlign: 'left', marginBottom: 12 }}>
          <span className="form-label">Email</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="input-glass"
          />
        </label>
        <label style={{ display: 'block', textAlign: 'left', marginBottom: 12 }}>
          <span className="form-label">Password</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="input-glass"
          />
        </label>
        <button disabled={isSubmitting} type="submit" className="btn-glass-primary btn-block">
          {isSubmitting ? 'Signing in…' : 'Log In'}
        </button>

        <div className="meta-text" style={{ marginTop: 10, opacity: 0.8 }}>or</div>
        <button
          type="button"
          className="btn-glass-secondary btn-google"
          disabled={isSubmitting}
          onClick={handleGoogle}
        >
          <span className="btn-google-badge" aria-hidden>G</span>
          Continue with Google
        </button>
        <p className="meta-text" style={{ marginTop: 12 }}>
          <span>Need an account? <Link to="/register" style={{ color: '#00bcd4' }}>Sign up</Link></span>
          <br />
          If you forgot your password, contact <a href="mailto:help@somethingcomical.com" style={{ color: '#00bcd4' }}>help@somethingcomical.com</a>
        </p>
      </form>
    </div>
  );
}
